import { render } from "./ImageChooser.vue?vue&type=template&id=35bd7f6f"
import script from "./ImageChooser.vue?vue&type=script&lang=js"
export * from "./ImageChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__